/**
 * Laufzeit-Umgebungswerte (Runtime-Config).
 *
 * Die umgebungsspezifischen OIDC-Werte (Authentik) kommen zur LAUFZEIT aus
 * `window.__ENV__`. Diese Variable wird vom nginx-Container beim Start aus
 * seinen Environment-Variablen erzeugt (siehe frontend/runtime/entrypoint.sh
 * + config.js.template; eingebunden via <script src="/config.js"> in
 * index.html). Fallback ist das Build-Env (import.meta.env.VITE_*), damit
 * `npm run dev` lokal weiter mit .env.local funktioniert.
 *
 * Dadurch ist EIN gebautes Frontend-Image fuer Stage UND Live identisch
 * (Image-Promotion): die Werte unterscheiden sich erst zur Laufzeit ueber
 * die jeweilige Server-.env, nicht ueber den Build.
 */

interface RuntimeEnv {
  OIDC_ISSUER?: string
  OIDC_CLIENT_ID?: string
}

const runtime: RuntimeEnv =
  (typeof window !== "undefined" && (window as unknown as { __ENV__?: RuntimeEnv }).__ENV__) || {}

// Ein nicht ersetzter envsubst-Platzhalter ("__OIDC_CLIENT_ID__") oder ein leerer
// String gilt als "nicht gesetzt" -> dann greift der Build-Fallback (lokal).
function resolve(runtimeValue: string | undefined, buildValue: string | undefined): string {
  const candidate = (runtimeValue ?? "").trim()
  const isPlaceholder =
    candidate === "" || (candidate.startsWith("__") && candidate.endsWith("__"))
  return isPlaceholder ? buildValue || "" : candidate
}

// OIDC_ISSUER = voller Authentik-Issuer, z.B.
//   https://auth.netzfabriks.cloud/application/o/netzfabriks-erp-stage-spa/
// OIDC_CLIENT_ID = public client_id der SPA-App in Authentik.
export const OIDC_ISSUER = resolve(runtime.OIDC_ISSUER, import.meta.env.VITE_OIDC_ISSUER)
export const OIDC_CLIENT_ID = resolve(runtime.OIDC_CLIENT_ID, import.meta.env.VITE_OIDC_CLIENT_ID)
